
export enum RuleFieldType {
  Text = "text",
  Number = "number",
  ColumnSelect = "column_select",
  ColumnSelectOrCreate = "column_select_or_create",
  Boolean = "boolean",
  Select = "select",
  SelectJson = "select_json",
  SelectOrCreate = "select_or_create",
  MultiSelect = "multiselect",
  ColumnMultiSelect = "column_multiselect",
  ColumnMultiSelectOrCreate = "column_multiselect_or_create",
  SourceDestinationPairArray = "source_destination_pair_array",
  Array = "array",
  Object = "object",
  Rule = "rule",
  Json = "json",
  ColorPicker = "color_picker",
  RegularExpression = "regex",
  StringTemplate = "string_template"
}